jQuery($ => {
    class Accordions {
      constructor(element) {
        this._               = element;
        this._element        = $(element);
        this._accordion      = this._element.find('.m-accordion');
        this._accordionTitle = this._element.find('.m-accordion__title');

        this._isAlternating = this._element.hasClass('m-accordions--alternating');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._accordionTitle.on('click', this.handleAccordionToggle);
        this._accordionTitle.on('keydown', this.handleAccordionKeydown);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Accordion Toggle
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleAccordionToggle = (event) => {
        if (!event) return;

        const target     = event.currentTarget;
        const $accordion = $(target).closest('.m-accordion');
        const isOpen     = $accordion.prop('open');

        if (isOpen) return;

        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        if (!this._isAlternating) return;

        this._accordion.not($accordion).prop('open', false);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Accordion Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleAccordionKeydown = event => {
        const target = event.currentTarget;
        const $item  = $(target).closest('.m-accordions__item');

        switch (event.key) {
          case "Enter":
          case "spacebar":
          case " ":
            this.handleAccordionToggle(event);
            break;

          case "ArrowUp":
            event.preventDefault();
            if ($item) {
              const $prevItem = $item.prev();

              if ($prevItem[0]) {
                $prevItem.find(".m-accordion__title").focus();
              }
            }
            break;

          case "ArrowDown":
            event.preventDefault();
            if ($item) {
              const $nextItem = $item.next();

              if ($nextItem[0]) {
                $nextItem.find(".m-accordion__title").focus();
              }
            }
            break;

          case "Home":
            event.preventDefault();
            if ($item) {
              $item
                .parent()
                .find(".m-accordions__item")
                .first()
                .find(".m-accordion__title")
                .focus();
            }
            break;

          case "End":
            event.preventDefault();
            if ($item) {
              $item
                .parent()
                .find(".m-accordions__item")
                .last()
                .find(".m-accordion__title")
                .focus();
            }
            break;
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.accordions = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].accordions = new Accordions(_[i], opt);
        else
          ret = _[i].accordions[opt].apply(_[i].accordions, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-accordions').accordions();
});